export function isElementVisible(element: HTMLElement | null): boolean {
    if (!element) {
        return false
    }

    const bounding = element.getBoundingClientRect()
    return (
        bounding.top >= 0 &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)
    )
}

export const entradasSaidas = [
    'ent1',
    'sai1',
    'ent2',
    'sai2',
    'ent3',
    'sai3',
    'ent4',
    'sai4',
    'ent5',
    'sai5',
    'ent6',
    'sai6',
    'ent7',
    'sai7',
    'ent8',
    'sai8',
    'ent9',
    'sai9',
    'ent10',
    'sai10',
    'ent11',
    'sai11',
    'ent12',
    'sai12',
] as const
